import { Component } from "@/types/types"
import { cx } from "@/utils/cx"

import { Link } from "../Link"

export const COMPONENT_NAME = "textLink"

export const presets = {
  style: {
    underline: "underline",
    bold: "font-semibold",
  },
}

export interface Props extends Component {
  href: string
  style?: keyof typeof presets.style
  newTab?: boolean
}

export function TextLink({
  href,
  style = "underline",
  newTab,
  children,
  className,
  testId = COMPONENT_NAME,
}: Props) {
  const styleClassName = presets.style[style]

  return (
    <Link
      href={href}
      newTab={newTab}
      className={cx(
        `leading-none focus:outline-none focus-ring rounded-sm`,
        styleClassName,
        className,
      )}
      testId={testId}
    >
      {children}
    </Link>
  )
}
